export default function () {
    const $blocks = $('.js-blog-archive');

    if (!$blocks.length) {
        return;
    }

    $blocks.each(function () {
        const $block = $(this);
        const $filters = $block.find('.js-blog-archive-filter');
        const $posts = $block.find('.js-blog-archive-posts');
        const $loadMore = $block.find('.js-blog-archive-load-more');
        const $scrollButton = $block.find('.js-header-news-scroll');
        const $scrollTarget = $block.find('.js-blog-archive-section');

        if (!$posts.length) {
            return;
        }

        let selectedFilter = 'all';
        let currentPage = parseInt($block.data('page'), 10) || 1;
        let maxPages = parseInt($block.data('max-pages'), 10) || 1;
        let isLoading = false;

        const updateLoadMoreState = () => {
            if (!$loadMore.length) {
                return;
            }

            if (currentPage >= maxPages) {
                $loadMore.addClass('is-hidden');
            } else {
                $loadMore.removeClass('is-hidden');
            }
        };

        const getNoPostsMessage = () => {
            const noPostsText = String($block.data('no-posts-label') || 'No posts found.');
            return `<p class="blog-archive__empty">${noPostsText}</p>`;
        };

        const fetchPosts = (reset = false) => {
            if (isLoading) {
                return;
            }

            const requestPage = reset ? 1 : currentPage + 1;

            isLoading = true;
            $block.addClass('is-loading');
            $loadMore.prop('disabled', true);

            $.ajax({
                type: 'POST',
                url: menaObject.ajaxurl,
                dataType: 'json',
                data: {
                    action: 'blog_archive_posts',
                    page: requestPage,
                    category: selectedFilter,
                    lang: $('body').data('lang-slug') || '',
                },
                success: function (response) {
                    if (!response || !response.success) {
                        return;
                    }

                    const responseData = response.data || {};
                    const html = responseData.html || '';

                    maxPages = parseInt(responseData.max_pages, 10) || 1;
                    currentPage = requestPage;

                    if (reset) {
                        $posts.html(html || getNoPostsMessage());
                    } else if (html) {
                        $posts.append(html);
                    }

                    $block.attr('data-page', currentPage);
                    $block.attr('data-max-pages', maxPages);
                    updateLoadMoreState();
                },
                complete: function () {
                    isLoading = false;
                    $block.removeClass('is-loading');
                    $loadMore.prop('disabled', false);
                },
            });
        };

        $scrollButton.on('click', function () {
            if (!$scrollTarget.length) {
                return;
            }

            $scrollTarget[0].scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });

        $filters.on('click', function () {
            const $filter = $(this);
            const filterValue = String($filter.data('filter') || 'all');

            if ($filter.hasClass('active') || isLoading) {
                return;
            }

            $filters.removeClass('active');
            $filter.addClass('active');
            selectedFilter = filterValue;
            fetchPosts(true);
        });

        $loadMore.on('click', function () {
            if (isLoading || currentPage >= maxPages) {
                return;
            }

            fetchPosts(false);
        });

        updateLoadMoreState();
    });
}
